




import { Component, Vue } from 'vue-property-decorator'
import roleSettingCom from '@/views/manage/roleManage/roleSettingCom.vue'

@Component({
  name: '',
  components: {
    roleSettingCom
  }
})
export default class extends Vue {
  dataObj = {
    type: 'tanentRole',
    detailUrl: '/blackcat/activation/type/detail',
    assignUrl: '/blackcat/activation/type/permission/assign'
  }
}
